export default __webpack_public_path__ + "static/media/Custom-HUD-Label.a400a52c.jpg";